module.exports = __webpack_public_path__ + "img/Antonia&Stephan-14.19b0262e.jpg";